module.exports = __webpack_public_path__ + "img/ip.f08c717.png";